export default {"src":"/_next/static/media/temp.c330d8ea.svg","height":17,"width":15};